export const spatialIntegrateLocalDataCN = {
    'Spatial.Integrate.Local.Data': '空间组学整合本地数据',
    'Spatial.Sample.One.Tip': '每次分析仅可上传一个样本。',
    'Spatial.Sample.Table.Spot.Counts': 'Spot Counts',
    'Spatial.Sample.Table.Bin.Size': '空间分辨率',
    'Spatial.Analysis.Platform': '平台',
    'Spatial.Analysis.Cluster.Number': '聚类数量',
    'Spatial.Analysis.Cluster.Range': '范围',
    'Spatial.Analysis.Cluster.Fixed': '固定值',
    'Spatial.Analysis.Cluster.Method': '聚类方法',
    'Spatial.Analysis.Cluster.Method.kmeans': 'kmeans',
    'Spatial.Analysis.Cluster.Method.mclust': 'mclust',
    'Spatial.Analysis.Notes.Title': '说明',
    'Spatial.Analysis.Notes.One.Sample': '每次分析仅可上传一个样本。',
    'Spatial.Analysis.Notes.Platform': '平台：10X Visium / Singleron DBiT-seq。',
    'Spatial.Analysis.Notes.Cluster.Number': '聚类数量：范围 2–10；固定值 5（可调整，须 > 0）。',
    'Spatial.Analysis.Notes.Cluster.Method': '聚类方法：kmeans（默认）或 mclust。',
    'Spatial.Analysis.Notes.PC': 'PC 值：默认 15（可调整，须 > 0）。',
    'Spatial.Analysis.Notes.HVG': '高变基因数：默认 2000。',
    'Spatial.Task.Title': '空间转录组数据集',
};

export const spatialIntegrateLocalDataUS = {
    'Spatial.Integrate.Local.Data': 'Spatial Integrate Local Data',
    'Spatial.Sample.One.Tip': 'Please upload only one sample per analysis.',
    'Spatial.Sample.Table.Spot.Counts': 'Spot Counts',
    'Spatial.Sample.Table.Bin.Size': 'Bin size',
    'Spatial.Analysis.Platform': 'Platform',
    'Spatial.Analysis.Cluster.Number': 'Cluster number',
    'Spatial.Analysis.Cluster.Range': 'Range',
    'Spatial.Analysis.Cluster.Fixed': 'Fixed value',
    'Spatial.Analysis.Cluster.Method': 'Cluster method',
    'Spatial.Analysis.Cluster.Method.kmeans': 'kmeans',
    'Spatial.Analysis.Cluster.Method.mclust': 'mclust',
    'Spatial.Analysis.Notes.Title': 'Note',
    'Spatial.Analysis.Notes.One.Sample': 'Only one sample per analysis.',
    'Spatial.Analysis.Notes.Platform': 'Platform: 10X Visium / Singleron DBiT-seq.',
    'Spatial.Analysis.Notes.Cluster.Number': 'Cluster number: Range 2–10; Fixed value 5 (adjustable, must be > 0).',
    'Spatial.Analysis.Notes.Cluster.Method': 'Cluster method: kmeans (default) or mclust.',
    'Spatial.Analysis.Notes.PC': 'PC value: Default 15 (adjustable, must be > 0).',
    'Spatial.Analysis.Notes.HVG': 'Number of highly variable genes: Default 2000.',
    'Spatial.Task.Title': 'Saptial Transcriptomics Datasets',
};
